import React from 'react';
import PropTypes from 'prop-types';
import { Col } from '@saucelabs/sl-component-grid';
import { ManualList, ManualListHeader, ManualListItem } from '@saucelabs/sl-component-manual-list';

import Styles from './DesktopBrowserConfiguratorResolution.styles';

const DesktopBrowserConfiguratorResolution = ({ onChange, current, resolutions }) => (
  <Col
    key="resolution"
    className={Styles.default}
    sm
    xs={12}
  >
    <ManualListHeader label={<div className={Styles.label}>Resolution</div>} />
    <ManualList>
      {resolutions.map((value) => {
        const onClick = (event) => {
          event.preventDefault();
          event.stopPropagation();

          return onChange(value);
        };

        return (
          <ManualListItem
            key={`${resolutions}-${value}`}
            active={current === value}
            name={value}
            onClick={onClick}
          />
        );
      })}
    </ManualList>
  </Col>
);

DesktopBrowserConfiguratorResolution.defaultProps = {
  current: null,
};

DesktopBrowserConfiguratorResolution.propTypes = {
  current: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  resolutions: PropTypes.array.isRequired,
};

export default DesktopBrowserConfiguratorResolution;
